import React, { useMemo } from "react";
import { normalizeTtsText } from "../tts";
import { useReadAloud } from "../hooks/useReadAloud";
import "./ReadAloudBar.css";

export default function ReadAloudBar({ text, lang, className = "" }) {
  const { toggle, isSpeaking } = useReadAloud(lang);
  const hasText = useMemo(() => Boolean(normalizeTtsText(text)), [text]);
  const labels = useMemo(() => {
    if (lang === "he") return { listen: "האזנה לטקסט", stop: "עצירת ההאזנה" };
    if (lang === "es") return { listen: "Escuchar texto", stop: "Detener" };
    return { listen: "Listen to text", stop: "Stop" };
  }, [lang]);

  return (
    <div
      className={`read-aloud-bar ${className}`.trim()}
      role="region"
      aria-label={labels.listen}
    >
      <button
        type="button"
        className="journey-btn journey-btn-secondary read-aloud-bar__btn"
        disabled={!hasText}
        onClick={() => toggle(text)}
        aria-pressed={isSpeaking}
      >
        {isSpeaking ? labels.stop : labels.listen}
      </button>
    </div>
  );
}
